exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__ListItem__root {\n  position: relative;\n  box-sizing: border-box;\n  align-items: center;\n  cursor: pointer;\n  background-color: #ffffff;\n  transition: background-color 0.3s;\n}\n\n  .DS__ListItem__root:hover,\n  .DS__ListItem__root:focus {\n    background-color: #f6f8fc;\n  }\n\n.DS__ListItem__view_desktop {\n    padding: 12px 16px;\n  }\n\n.DS__ListItem__view_mobile {\n\n    min-height: 56px;\n    padding: 12px 12px;\n  }\n\n.DS__ListItem__view_mobile::after {\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      height: 1px;\n      margin-right: 12px;\n      margin-left: 12px;\n      content: '';\n      background-color: #dde3ed;\n    }\n", ""]);

// exports
exports.locals = {
	"root": "DS__ListItem__root",
	"view_desktop": "DS__ListItem__view_desktop",
	"view_mobile": "DS__ListItem__view_mobile"
};